module.exports = __webpack_public_path__ + "assets/c5446691023520de7724dd37c2e77ffe.svg";